const tabs = {
  dashboard: "Dashboard",
  appLauncher: "All Apps",
  apps: "All Apps",
  layers: "Hub",
  vcards: "vCards",
  // Legacy names — kept so old keys still resolve; the app itself is vCards now.
  editor: "Editor",
  vtaskPool: "Task Pool",
  storyMap: "vStory",
  notebook: "Notebook",
  memory: "Memory",
  chat: "Internal Chat",
  news: "Newsroom",
  osMap: "OS Map",
  virtualOffice: "Virtual Office",
  roadmapBlack: "Roadmap — The Spine",
  specs: "System Spec",
  functionalMap: "Functional Map",
  budget: "vBudget · Cashflow",
  aiHub: "AI Hub",
  aiHome: "AI Home",
  cliAi: "CLI AI",
  aiAdvisors: "AI Advisors",
  advisors: "AI Advisors",
  agents: "Agents (Coming Soon)",
  aiKnowledge: "AI Knowledge (Coming Soon)",
  semanticBrain: "Brain Health",
  libraries: "Libraries",
  fieldTemplates: "Field Templates (Coming Soon)",
  iconLibrary: "Icon Library",
  databases: "Views | DB",
  integrations: "Integrations",
  myConnections: "My Connections",
  appStore: "App Store",
  sync: "Origami Sync",
  vault: "vPassword",
  vaultPasswords: "Passwords",
  vaultSecrets: "Encrypted Data",
  vaultAudit: "Drift Audit",
  vaultTeam: "Team Vault",
  vcloud: "vCloud",
  vcloudFiles: "Files",
  vcloudImages: "Image Library",
  vcloudVideo: "Video",
  vcloudSound: "Sound",
  vcloudPersonal: "Personal Info",
  designSystem: "Design System",
  architecture: "Architecture",
  plan: "Plan",
  roadmap: "Work Management",
  vTool: "vTool",
  settings: "Settings",
  automations: "Automations",
  vdev: "PM — Development Management",
  taskInbox: "vTask | Task Pool",
  control: "Control Center",
  admin: "Dev Log",
  adminDataBrain: "Data & Brain",
  health: "System Health",
  systemCleanup: "System Cleanup",
  serverHealth: "Server Health",
  integrationHealth: "Integration Health",
  honeypot: "Honeypot Traps",
  maintenance: "Code Maintenance",
  dbExplorer: "DB Explorer",
  dbRegistry: "Table Index",
  referenceApp: "Reference App",
  notionOrder: "Notion Order",
  alerts: "🤖 Alerts Hub",
  identityResolver: "Business Identity Resolver",
  agentAccess: "🔑 Agent Access",
  entities: "Entities",
  viewsApp: "Views",
  pinkas100: "Contractors 100",
  pinkasKablanim: "Contractors Registry",
  investigator: "Business Intelligence",
  memoryCatalog: "Memory Library",
  bookmarksApp: "Bookmarks",
  ideaBacklog: "Ideas & Planning",
  windmill: "Windmill",
  embeddedTools: "Embedded Tools",
  entityFields: "Field Library",
  entityTypes: "Entity Types",
  knowledge: "Knowledge",
  knowledgeSources: "Knowledge Sources",
  researchLibrary: "Research Library",
  playbooks: "Playbooks",
  skills: "Claude Stack",
  skillsStore: "Templates Store (Coming Soon)",
  grid: "Grid",
  slides: "Slides",
  boardroom: "Board Room",
  feeds: "RSS Feeds",
  bookmarks: "Bookmarks",
  readList: "Read List (Coming Soon)",
  import: "Import",
  matching: "Matching",
  matchingEngine: "Matching Engine",
  talentSearch: "Talent Search",
  comms: "Communication",
  whatsapp: "WhatsApp",
  documents: "Documents",
  vclip: "vClip",
  vcanvas: "vCanvas",
  weeklyPlanner: "Weekly Planner",
  audit: "Audit Log",
  templates: "Templates",
  emailTemplates: "Email Templates",
  phoneTemplates: "Phone Templates (Coming Soon)",
  prompts: "Prompts (Coming Soon)",
  toolkit: "Toolkit",
  courses: "Course Library",
  cost: "Cost Control",
} as const;
export default tabs;
